export default __webpack_public_path__ + "static/media/leavesImg.af7382b0.png";